import { Component, EventEmitter, Input, Output } from '@angular/core';
import { JobListingItem } from '../../jobs-module/models/listing.model';

@Component({
  selector: 'mj-job-jobs',
  templateUrl: './job-jobs.component.html',
  styleUrls: ['./job-jobs.component.scss'],
})
export class JobJobsComponent {
  @Input() public listingItem: JobListingItem;

  @Output() public onItemScheduledForRemoval = new EventEmitter<
    JobListingItem
  >();
}
